import { render } from "./NomenclatoareResurseUmane.vue?vue&type=template&id=1596f63a&scoped=true&ts=true"
import script from "./NomenclatoareResurseUmane.vue?vue&type=script&lang=ts"
export * from "./NomenclatoareResurseUmane.vue?vue&type=script&lang=ts"

import "./NomenclatoareResurseUmane.vue?vue&type=style&index=0&id=1596f63a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1596f63a"]])

export default __exports__